export default __webpack_public_path__ + "static/media/hard_tellin.8b14e38f.jpeg";